<template>
  <div class="device-wrap">
    <div class="scroll">
      <div class="deivce-cards-container">
        <div class="wran-box" v-for="(item, index) in drvicePos" :key="index" v-if="item.drvices.length">
          <div
            class="wran-header"
            :style="{
              background: `linear-gradient(to right,${item.color},${item.color}b1)`,
            }"
          >
            <div>{{ item.label }}</div>

            <el-button
              icon="el-icon-plus"
              circle
              slot="reference"
              size="mini"
              @click="addtoScreen(item.id)"
            ></el-button>
            
          </div>
          <div class="wran-content">
            <div
              class="wran-item-content"
              v-for="item2 in item.drvices"
              :key="item2.id"
            >
              <div class="wran-label">{{ item2.label }}</div>
              <div class="wran-state">
                <div class="wran-data-list">
                  <div
                    class="wran-data-item"
                    v-for="(item3, index2) in item2.data"
                    :key="index2"
                  >
                    {{ item3.label }} <span style="color:#cc6666;font-weight:bold;">{{ Number(item3.value)?Number(item3.value).toFixed(2):item3.value }}</span> 
                  </div>
                </div>
                <div>
                  <div
                    class="run"
                    v-if="item2.state == drviceState.start"
                  ></div>
                  <div
                    class="stop"
                    v-if="item2.state == drviceState.stop"
                  ></div>
                  <div
                    class="error"
                    v-if="item2.state == drviceState.error"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="apps-img-btn" @click="$Application.close('device-cards')">
      <img src="@/assets/apps-icon.png" alt="" srcset="" />
      <div class="btn-title">设备总览</div>
    </div>
  </div>
</template>
<script>
import scrollX from "./scroll-x";
// 设备模块状态枚举
const drviceState = {
  start: "运行",
  stop: "停止",
  error: "故障",
};

export default {
  data() {
    return {
      ops: {
        vuescroll: {
          locking: false,
          sizeStrategy: "number",
        },
        scrollPanel: {},
        rail: {},
        bar: {},
      },
      visible: false,
      drviceState,
      drvicePos: [],
    };
  },
  watch: {
    drvicePos() {
      setTimeout(() => {
        // scrollX(".scroll", {
        //   step: 100,
        //   duration: 500,
        //   ease: "cubic-bezier(0.22, 0.61, 0.36, 1)",
        //   child: ".wran-box",
        //   type: "lastchild",
        // });
      }, 1000);
    },
  },
  mounted() {
    this.DPC = this.$Core.getProvider("DPC");
    this.Mock = this.$Core.getProvider("Mock");
    this.$nextTick(() => {
      // scrollX(".scroll", {
      //   step: 100,
      //   duration: 500,
      //   ease: "cubic-bezier(0.22, 0.61, 0.36, 1)",
      //   child: ".wran-box",
      //   type: "lastchild",
      //   onscroll:(d)=>{
      //     console.log(d)
      //   }
      // });
    });
    this.getModules();
  },
  methods: {
    addtoScreen(id) {
      let devicesCard =  localStorage.devicesCard || [];
      if(typeof devicesCard == 'string'){
        devicesCard = JSON.parse(localStorage.devicesCard);
      }
      
      if (confirm("添加卡片到屏幕？")) {
        if (!devicesCard) {
          devicesCard = [];
        }
        devicesCard.push(id);
      }
      localStorage.devicesCard = JSON.stringify(devicesCard);
      // 广播
      this.$Application.broadcast("devicesCard", devicesCard);
    },
    getModules() {
      // 获取未修改过多嗯原始数据
      this.drvicePos = this.Mock.getModules();
    },
  },
};
</script>
<style lang="scss" scoped>
$radius: 20px;
.scroll {
  height: 100%;
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  // overflow-y: hidden;
  overflow-x:scroll;
  &::-webkit-scrollbar{
    height: 15px;
    width: 10px;
  }
  &::-webkit-scrollbar-thumb{
    background: #008585;
  }
  &::-webkit-scrollbar-button{
    
    background: #000;
  }
}
.device-wrap {
  width: 100%;
  height: 100%;
  position: relative;
  background: rgba($color: #000000, $alpha: 0.5);
  backdrop-filter: blur(10px);
  .apps-img-btn {
    width: 80px;
    height: 80px;
    padding: 15px;
    cursor: pointer;
    box-sizing: border-box;
    position: absolute;
    left: 50%;
    bottom: 60px;
    transform: translate(-50%) scale(1);
    border-radius: 100%;
    border: 1px solid #0182e2;
    box-shadow: 0 0 10px 0 #0182e2;
    background: rgba($color: #000, $alpha: 0.2);
    animation: all 0.4s;
    &:hover {
      animation: all 0.4s;
      transform: translate(-50%) scale(0.9);
    }
    .btn-title {
      color: #fff;
      // font-size: 12px;
      position: absolute;
      bottom: -40%;
      left: 0;
      text-align: center;
      width: 100%;
      // transform: translateX(-50%);
    }
    img {
      height: 100%;
      width: 100%;
      pointer-events: none;
      animation: heart 1s infinite alternate;
    }

    @keyframes heart {
      from {
        transform: scale(1);
      }
      from {
        transform: scale(0.9);
      }
    }
  }
}
.deivce-cards-container {
  display: flex;
  flex-direction: column;

  //   flex-direction: row-reverse;
  flex-wrap: wrap;
  //   width: 60%;
  height: 100%;
  flex-shrink: 0;
  align-content: flex-start;
  // justify-content: flex-end;
}
.wran-box {
  flex-shrink: 0;
  //   align-self: flex-end;
  margin: 5px;
  background: rgba($color: #003764, $alpha: 0.6);
  // backdrop-filter: blur(10px);
  border-radius: $radius;
  width: 340px;
  color: #fff;
  box-shadow: inset 0px 4px 20px #159aff;
  cursor: pointer;
  // pointer-events: none;
  .wran-header {
    border-radius: $radius $radius 0 0;
    padding: 10px 15px;
    font-size: 22px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-image: linear-gradient(
      to right,
      rgba($color: #0182e2, $alpha: 0.6),
      rgba($color: #1cdde6, $alpha: 0.6)
    );

    .statistics-img {
      height: 20px;
      width: auto;
    }
  }
  .wran-content {
    font-size: 14px;
    font-weight: 700;
    padding: 15px;
    // display: grid;
    grid-template-columns: repeat(3, auto);
    grid-gap: 1rem;
    grid-template-rows: 100px;
    .wran-item-content {
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &:nth-last-child(1) {
        margin: 0;
      }
      .wran-state {
        display: flex;
        overflow: hidden;
        white-space: nowrap;
        .wran-data-item {
          margin-right: 10px;
          font-size: 14px;
          font-weight: 100;
          margin-bottom: 10px;
          width: 120px;
          overflow: hidden;
          white-space: nowrap;
          // text-overflow: ellipsis;
        }
        .wran-data-item:nth-last-child(1) {
          margin-bottom: 0;
        }
        .run,
        .stop,
        .error {
          width: 20px;
          height: 20px;
          background: #0182e2;
        }
        .stop {
          background: #ebe195;
        }
        .error {
          background: #f38f4a;
        }
      }
    }
  }

  .down-img {
    width: 20px;
    position: absolute;
    bottom: -30px;
    left: 50%;
    transform: translateX(-50%);
    animation: downImg 0.4s linear infinite alternate;
  }
  @keyframes downImg {
    from {
      bottom: -30px;
    }
    to {
      bottom: -35px;
    }
  }
}
</style>